import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/Common/Button/Button';
import styles from './LoginScreen.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { CircleSpinner } from 'react-spinners-kit';
import { setCanRefresh } from '../../../actions/appActions';

const Login = ({ history }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const app = useSelector((state) => state.app);
  const [loadingBackground, setLoadingBackground] = useState(true);
  const [loadingLogo, setLoadingLogo] = useState(true);
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  const [backgroundMedia, setBackgroundMedia] = useState(null);
  const [appLogo, setAppLogo] = useState(null);

  useEffect(() => {
    if (app.media) {
      setBackgroundMedia(app.media.find((m) => m.type === 'BACKGROUNDAPP'));
      setAppLogo(app.media.find((m) => m.type === 'LOGO_TRANSPARENT'));
    }
  }, [app]);

  useEffect(() => {
    dispatch(setCanRefresh(false));

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        setIsVisible(false);
      } else if (document.visibilityState === 'visible') {
        setIsVisible(true);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      dispatch(setCanRefresh(true));
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (videoRef.current) {
      if (isVisible) {
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  }, [isVisible]);

  const onSignInHandle = () => {
    history.push({
      pathname: '/login-user',
    });
  };

  const handleImageLoad = () => {
    setLoadingBackground(false);
  };

  const handleLogoLoad = () => {
    setLoadingLogo(false);
  };

  return (
    <div className={styles.container}>
      {loadingBackground && loadingLogo && (
        <div className='loading-app'>
          <div className='loaderDiv'>
            <CircleSpinner
              className='spinner-app mx-auto'
              style={{ margin: 'auto' }}
              size={40}
              color='var(--color-font-primary)'
            />
          </div>
        </div>
      )}
      {appLogo && (
        <div className='position-absolute w-100'>
          <div className='row justify-content-center'>
            <div className='col-12 col-md-6 col-lg-5 p-md-0 text-center'>
              <img
                onLoad={handleLogoLoad}
                src={appLogo.value}
                className={`${styles.logoType} ${styles.noSelect}`}
                alt='background-img'
              />
            </div>
          </div>
        </div>
      )}
      {backgroundMedia?.value.includes('.mp4') ? (
        <video
          ref={videoRef}
          className={styles.imgBkg}
          style={{
            display: loadingBackground ? 'none' : 'block',
          }}
          autoPlay
          muted
          loop={isVisible}
          playsInline
          onLoadStart={handleImageLoad}
          webkit-playsinline='true'
          x5-playsinline='true'
          src={backgroundMedia?.value}
        />
      ) : (
        <img
          src={backgroundMedia?.value}
          className={styles.imgBkg}
          style={{
            display: loadingBackground ? 'none' : 'block',
          }}
          onLoad={handleImageLoad}
          alt='background-img'
        />
      )}

      {!loadingBackground && (
        <div className='mb-5 px-3' style={{ position: 'absolute', bottom: '0', width: '100%' }}>
          <div className='row justify-content-md-center'>
            <div className='col-12 col-md-6 col-lg-5 p-md-0'>
              <div className='mt-3'>
                <Button
                  size={'large'}
                  onClick={onSignInHandle}
                  text={
                    <>
                      <span className='font-normal2'>{t('login.signIn')}</span>
                    </>
                  }
                  color='#fff'
                  backgroundColor='#050708'
                  hasBorder={true}
                  className={styles.noSelect}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
